import type {ReactElement} from 'react';
import {ControlledList} from '@Components/controlled-list';
import {buildReplaceSourceOptions} from '@Components/media-source-menu/media-source-menu.library';
import {toReplaceDropdownListItems} from '@Components/media-source-menu/replace-source-rows.library';
import type {ReplaceMediaControlsProps} from './replace-media-controls.types';
import {REPLACE_MEDIA_ROW_ID_PREFIX} from './replace-media-controls.types';

/**
 * The desktop replace menu: a flat Uploads / Explore media / AI list. The AI rows and the stock
 * panel Explore media opens are keyed to the replaced item's medium via mediaKind.
 */
export function ReplaceMediaControls(props: ReplaceMediaControlsProps): ReactElement {
  return (
    <ControlledList
      className="spacing-m-0"
      items={toReplaceDropdownListItems(buildReplaceSourceOptions(props.mediaKind, {idPrefix: REPLACE_MEDIA_ROW_ID_PREFIX, onSelect: props.onSelect}))}
    />
  );
}
